export const FILTERS_ORDER_SETTINGS_KEY_VERSION_INPUTS = "version-inputs";
